export default __webpack_public_path__ + "static/media/star.85cf5d53.svg";